import { useState, useEffect, useRef } from 'react';

import useFixedElement from './../hooks/useFixedElement';

export default function PageTopBanner() {
	const pageBannerRef = useRef(null);
	const [offsetTop, setOffsetTop] = useState(0);
	const isFixed = useFixedElement(offsetTop);

	useEffect(() => {
		const pageBanner = pageBannerRef.current;
		if (pageBanner) setOffsetTop(pageBanner.offsetHeight);
	}, [offsetTop]);

	return <div ref={pageBannerRef} className={`page-top-banner ${isFixed ? 'fixed' : ''}`}></div>;
}
